import { Base } from './Base';
import breakpoints from "../../constants/breakpoints";

const selectors = {
  tab: ".conditions__tab-link",
  detail: ".conditions__tab-detail",
};

export class Conditions extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.firstActive = this.setActive = this.element.dataset.setActive;
    this.cacheNodes();

    if (this.tabs.length) {
      this.bindEventListeners();
      this.setEventListeners();
      this.constructState();
      this.setActiveTab();
    }
  }

  isMobile() {

    if (window.innerWidth >= breakpoints.MD) {
      return false;
    }
    return true;
  }

  cacheNodes() {
    this.tabs = this.element.querySelectorAll(selectors.tab);
    this.details = this.element.querySelectorAll(selectors.detail);
  }

  bindEventListeners() {
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
  }

  setEventListeners() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("mouseenter", this.handleMouseOver);
      tab.addEventListener("mouseleave", this.handleMouseOut);
    });
  }

  constructState() {
    const _this = this;
    const active = this.firstActive;

    this.state = {
      _active: active,
      set active(ref) {
        this._active = ref;
        _this.setActiveTab();
      },
      get active() {
        return this._active;
      },
    };
  }

  handleMouseOut(e) {
    if (this.isMobile()) {
      return;
    }
    this.state.active = this.firstActive;
  }

  handleMouseOver(e) {
    if (this.isMobile()) {
      return;
    }
    this.state.active = e.target.dataset.ref;
  }

  setActiveTab() {
    const active = this.state.active;

    this.tabs.forEach((tab) => {
      const ref = tab.dataset.ref;
      if (ref === this.firstActive) {
        tab.classList.add("active");
      } else {
        tab.classList.remove("active");
      }
    });

    this.details.forEach((detail) => {
      const ref = detail.dataset.ref;
      if (ref === active) {
        detail.classList.add("active");
      } else {
        detail.classList.remove("active");
      }
    });
  }
}